/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 23/05/2025 19:19
 *
 */

import { MenuItem } from '@infodata-group/inf-commons';
import { CARTOGRAPHY_FOLDER_ID } from '@monorepo-projects/alwayson-shared';
import { GenericCrudAuthorization } from './menu/generic-crud-authorization';
import { GenericMenuItemNode } from './menu/generic-menu-item-node';
import { Layout } from './menu/layout';

export class StandardMenuItem extends MenuItem {
  public CRUD = new GenericCrudAuthorization();
  public layout = new Layout('');
  // @ts-expect-error: Property 'submenus' is missing in type 'StandardMenuItem' but required in type 'MenuItem'
  public override submenus: StandardMenuItem[];
  public parentId: string;
  public rflobj: string;
  private _companyId: string;

  set companyId(id: string) {
    this._companyId = id;
    this.submenus.map((s) => (s.companyId = id));
  }

  constructor(id: string, label: string, icon: string, route?: string) {
    super(id, label, icon ? icon : '', '');
    if (
      route &&
      (route.startsWith('http://') || route.startsWith('https://'))
    ) {
      this.route = route;
      return;
    }

    if (route && !route.startsWith('/')) {
      route = `/${route}`;
    }
    this.route = route ? route : null;
  }
  public serialize(): any {
    return {
      id:
        this.parentId && !this.id.includes('_S$')
          ? `${this.id}_S$${this._companyId}`
          : this.id,
      label: this.label,
      icon: this.icon,
      route: this.route,
      layout: this.layout.serialize(),
      disabled: !!this.disabled,
      children: this.submenus.map((x) => x.serialize()),
    };
  }

  /**
   * Check if matching in objet & submenu
   * Retur both in case of child matching
   * @param value: string
   * @param key: string
   */
  public isMatching(value: string, key: string): StandardMenuItem[] {
    const items: StandardMenuItem[] = [];
    if (this[key] === value) {
      items.push(this);
      return [this];
    }
    const submenu = this.submenus.find((x) => x[key] === value);
    if (submenu) {
      return [this, submenu];
    }
    return [];
  }

  public isMatchingRecursive(
    value: string,
    key: string,
    items: StandardMenuItem[],
  ): StandardMenuItem[] {
    if (this[key] === value) {
      items.unshift(this);
      return items;
    }

    for (const submenu of this.submenus) {
      const isMatching = submenu.isMatchingRecursive(value, key, items);
      if (isMatching.length > 0) {
        items.unshift(this);
        return items;
      }
    }
    return [];
  }

  public toNode(node?: GenericMenuItemNode): GenericMenuItemNode {
    const itemNode = new GenericMenuItemNode(this);
    if (this.hasSubMenus()) {
      // Recursive call
      this.submenus.map((x) => x.toNode(itemNode));
    }
    if (node) {
      node.nodes.push(itemNode);
    }
    return itemNode;
  }

  public openFirstChild(): StandardMenuItem {
    if (this.id === CARTOGRAPHY_FOLDER_ID) {
      const presetChild = this.submenus.at(-1);
      if (presetChild) {
        return presetChild.openFirstChild();
      }
    }

    if (this.route !== null) {
      this.isOpen = true;
      return this;
    }
    if (this.hasSubMenus()) {
      for (const submenu of this.submenus) {
        return submenu.openFirstChild();
      }
    }
    return null;
  }
}
